module.exports =  [
    {
      src: 'https://storage.googleapis.com/spotin/brands/23/logo/logo.svg',
      alt: 'A Days March',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/6/logo/logo.svg',
      alt: 'Adnym Atelier',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/39/logo/logo.svg',
      alt: 'Akenberg',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/40/logo/logo.svg',
      alt: 'Amendi',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/4/logo/logo.svg',
      alt: 'Apart of the Art',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/16/logo/logo.svg',
      alt: 'Avenue Tropicale',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/25/logo/logo.svg',
    //   alt: 'Axel Arigato',
    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/38/logo/logo.svg',
      alt: 'Baron',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/88/logo/logo.svg',
      alt: 'Berkeley Shirts',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/26/logo/logo.svg',
    //   alt: 'Björn Borg',

    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/77/logo/logo.svg',
      alt: 'Bon Voy Bags',
    },
       {
      src: 'https://storage.googleapis.com/spotin/brands/79/logo/logo.svg',
      alt: 'Bonnierförlagen',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/27/logo/logo.svg',
      alt: 'Boom Watches Company',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/19/logo/logo.svg',
    //   alt: 'Boomerang',
    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/106/logo/logo.svg',
      alt: 'Boygal',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/17/logo/logo.svg',
      alt: 'BRIXTOL TEXTILES',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/10/logo/logo.svg',
      alt: 'CDLP',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/113/logo/logo.svg',
      alt: 'Cathrine Hammel',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/8/logo/logo.svg',
      alt: 'CHIMI Eyewear',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/59/logo/logo.svg',
      alt: 'CHPO',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/89/logo/logo.svg',
      alt: 'Clean Eating',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/22/logo/logo.svg',
      alt: 'Cojones',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/21/logo/logo.svg',
      alt: 'CQP',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/11/logo/logo.svg',
      alt: 'Cross Sportswear',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/28/logo/logo.svg',
      alt: 'Dedicated',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/7/logo/logo.svg',
      alt: 'Demadly',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/105/logo/logo.svg',
      alt: 'Diawéne',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/90/logo/logo.svg',
      alt: 'Erington',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/57/logo/logo.svg',
      alt: 'ETON Shirts',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/108/logo/logo.svg',
      alt: 'Fall Winter Spring Summer',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/114/logo/logo.svg',
      alt: 'Gauhar Helsinki',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/5/logo/logo.svg',
      alt: 'Glacial',
    },
    // {
    //   // src: 'https://storage.googleapis.com/spotin/brands/38/logo/logo.svg',
    //   alt: 'Götrich & Co',
    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/80/logo/logo.svg',
      alt: 'Hajk',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/41/logo/logo.svg',
      alt: 'Hashtag Bags',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/112/logo/logo.svg',
      alt: 'Hasla',
    },

    {
      src: 'https://storage.googleapis.com/spotin/brands/20/logo/logo.svg',
      alt: 'Henri-Lloyd',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/72/logo/logo.svg',
      alt: 'Human Scales',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/14/logo/logo.svg',
      alt: 'I am Runbox',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/94/logo/logo.svg',
      alt: 'Ida Sjostedt',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/91/logo/logo.svg',
      alt: 'Juniper',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/92/logo/logo.svg',
      alt: 'Kaiserin',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/32/logo/logo.svg',
      alt: 'Knowledge Cotton Apparel',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/74/logo/logo.svg',
    //   //alt: 'Kordie by Kordie',
    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/97/logo/logo.svg',
      alt: 'Little Liffner',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/13/logo/logo.svg',
      alt: 'Lugi Crespo',
    },
      {
      src: 'https://storage.googleapis.com/spotin/brands/81/logo/logo.svg',
      alt: 'Maxjenny!',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/86/logo/logo.svg',
      alt: 'Modalo',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/64/logo/logo.svg',
      alt: 'Moss & Noor',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/42/logo/logo.svg',
      alt: 'Myrqvist',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/58/logo/logo.svg',
      alt: 'Naim',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/53/logo/logo.svg',
    //   alt: 'Nikben',
    // },
    {
      src: 'https://storage.googleapis.com/spotin/brands/109/logo/logo.svg',
      alt: 'Nikolaj Storm',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/102/logo/logo.svg',
      alt: 'Nividas',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/95/logo/logo.svg',
      alt: 'NO/AN Studio',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/37/logo/logo.svg',
      alt: 'OAS',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/78/logo/logo.svg',
      alt: 'One We Like',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/93/logo/logo.svg',
      alt: 'Pargo Jewelry',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/56/logo/logo.svg',
      alt: 'Peak Performance',
    },
    //{
     // src: 'https://storage.googleapis.com/spotin/brands/67/logo/logo.svg',
     // static: true,
     // alt: 'Poddbuddy',
    //},
    {
      src: 'https://storage.googleapis.com/spotin/brands/3/logo/logo.svg',
      alt: 'Residus',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/9/logo/logo.svg',
      alt: 'Sandays Footwear',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/110/logo/logo.svg',
      alt: 'sania d\'mina',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/85/logo/logo.svg',
      alt: 'Santosh',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/87/logo/logo.svg',
      alt: 'Sniph',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/98/logo/logo.svg',
      alt: 'SophieBySophie',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/66/logo/logo.svg',
      alt: 'SON',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/69/logo/logo.svg',
      alt: 'Steele & Borough',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/100/logo/logo.svg',
      alt: 'Stine Goya',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/70/logo/logo.svg',
      alt: 'Strikk',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/15/logo/logo.svg',
      alt: 'Swedish Stockings',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/34/logo/logo.svg',
      alt: 'Swims',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/111/logo/logo.svg',
      alt: 'Swimslow',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/96/logo/logo.svg',
      alt: 'Teija',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/68/logo/logo.svg',
      alt: 'The Sleepy Collection',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/73/logo/logo.svg',
      alt: 'Tryst',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/35/logo/logo.svg',
      alt: 'Urban Pioneers',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/12/logo/logo.svg',
      alt: 'Vasuma',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/84/logo/logo.svg',
      alt: 'Handsome Stockholm',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/94/logo/logo.svg',
      alt: 'Ida Sjöstedt',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/105/logo/logo.svg',
      alt: 'Dieawene',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/107/logo/logo.svg',
      alt: 'Annele',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/116/logo/logo.svg',
      alt: 'Ivana Helsinki',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/117/logo/logo.svg',
      alt: 'DAY Birger et Mikkelsen',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/118/logo/logo.svg',
      alt: 'HOPE',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/119/logo/logo.svg',
      alt: 'Ennui',
    },
    {
      src: 'https://storage.googleapis.com/spotin/brands/121/logo/logo.svg',
      alt: 'Pura Utz',
    },
    // {
    //   src: 'https://storage.googleapis.com/spotin/brands/2/logo/logo.svg',
    //   alt: 'Whyred',
    // },
  ];



// WEBPACK FOOTER //
// ./pages/content/sellers.js